<template>
  <v-layout row justify-center>
    <v-dialog scrollable v-model="dialog" persistent max-width="500">
      <template v-slot:activator="{ on }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              @click="openEditorDocTypes()"
              v-on="on"
              fab
              dark
              small
              class="verySmall ml-0"
              color="light-blue darken-4"
            >
              <v-icon dark style="font-size:16px;">add</v-icon>
            </v-btn>
          </template>
          <span>Adicionar / Editar</span>
        </v-tooltip>
        <!-- <v-btn color="primary" dark v-on="on">Open Dialog</v-btn> -->
      </template>
      <v-card>
        <v-card-title
          class="subheading font-weight-bold grey--text text--darken-2"
        >Adicionar / Editar tipos de documentos</v-card-title>

        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              style="right:40px; top: 0;"
              class="mt-5 mr-0"
              v-on="on"
              absolute
              dark
              small
              fab
              top
              right
              color="primary"
              @click="newDocType"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <span>Adicionar novo tipo</span>
        </v-tooltip>

        <v-card-text>
          <v-data-table hide-actions :headers="headers" :items="docTypes || []" class="elevation-1">
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ props.header.text }}</span>
                </template>
                <span>{{ props.header.text }}</span>
              </v-tooltip>
            </template>
            <template v-slot:items="props">
              <td class="text-xs-left">
                <v-text-field
                  :disabled="props.item.disab"
                  :ref="props.item.id"
                  class="caption"
                  :rules="[]"
                  v-model="props.item.type"
                ></v-text-field>
              </td>
              <td class="text-xs-right">
                <v-icon
                  small
                  @click="saveType(props.item)"
                  v-if="!props.item.disab"
                  color="light-blue darken-4"
                  class="mr-2"
                >check</v-icon>

                <v-icon
                  small
                  @click="removeNewItem(props.item)"
                  v-if="!props.item.disab"
                  color="primary"
                >delete_forever</v-icon>

                <v-icon
                  v-if="props.item.disab"
                  small
                  class="mr-2"
                  @click="editItem(props.item)"
                >edit</v-icon>
                <v-icon
                  v-if="props.item.disab"
                  small
                  class="mr-2"
                  @click="connfirmDelType(props.item)"
                >delete</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blueGrey darken-1" flat @click="verifyToClose">Cancelar</v-btn>
          <v-btn color="primary" flat @click="verifyToClose">Aplicar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      headers: [
        { text: "Tipos do documento", sortable: false, value: "type" },
        { text: "", sortable: false, value: "" }
      ],
      dialog: false
    };
  },
  props: {
    //docTypes: Array,
    reloadDocTypes: Function
  },
  computed: {
    docTypes: {
      get() {
        return this.$store.state.documents.docTypesList;
      },
      set(value) {
        let obj = { docTypes: value };
        //console.log(obj);
        this.$store.commit("documents/updateDocsList", obj);
      }
    }
  },
  methods: {
    verifyToClose() {
      this.docTypes = this.docTypes.filter(doc => {
        return doc.id.toString().indexOf("temp-") == -1;
      });
      this.dialog = false;
    },
    removeNewItem(type) {
      // console.log('aqui')
      if (type.id.toString().indexOf("temp-") > -1) {
        this.docTypes = this.docTypes.filter(doc => {
          return doc.id.toString().indexOf("temp-") == -1;
        });
        return;
      }
      this.connfirmDelType(type);
    },
    connfirmDelType(data) {
      let obj = {
        message: `Você deseja excluir o tipo "${data.type}"?`,
        title: "Excluir tipo de documento",
        callback: _ => {
          this.doDelType(data);
        },
        type: "warning",
        btConfirm: { name: "Sim", show: true },
        btCancel: { name: "Não", show: true }
      };
      this.$store.commit("confirmMessage/showConfirmMessage", obj);
    },
    doDelType(data) {
      let obj = {
        url: "/api/typefile/" + data.id,
        query: "",
        method: "delete"
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        if (!response) {
          return;
        }
        let opts = {
          message: `Tipo removido com sucesso`,
          type: "success"
        };
        this.$store.commit("showAlert", opts);
        //this.dialog = false;
        console.log('berca')
        this.reloadDocTypes('clear');
      });
    },
    saveType(type) {
      let setMethod;
      let query = {};
      if (type.id.toString().indexOf("temp-") > -1) {
        query.id = null;
        setMethod = "post";
      } else {
        query.id = type.id;
        setMethod = "patch";
      }
      query.name = type.type;
      let url =
        setMethod === "patch" ? "/api/typefile/" + query.id : "/api/typefile";
      let obj = {
        url: url,
        query: query,
        method: setMethod
        // noLoader: true
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        if (!response) {
          this.reloadDocTypes();
          return;
        }
        //type.disab = true;
        this.reloadDocTypes();
        let opts = {
          message: `Tipo de documento ${
            type.id ? "alterado" : "adicionado"
          } com sucesso`,
          type: "success"
        };
        this.$store.commit("showAlert", opts);
      });
    },
    newDocType() {
      let temId = "temp-" + new Date().getTime();
      const newLine = {
        id: temId,
        disab: false,
        type: ""
      };
      this.docTypes.unshift(newLine);
      this.$nextTick(() => this.$refs[temId].focus());
    },
    openEditorDocTypes() {
      this.dialog = true;
    },
    editItem(data, label) {
      data.disab = false;
      let idFocus = data.id.toString();
      this.$nextTick(() => this.$refs[idFocus].focus());
    },
    confirmDelItem() {}
  }
};
</script>
<style>
.verySmall {
  width: 20px !important;
  height: 20px !important;
}
</style>